import { render, staticRenderFns } from "./InternalTuCreateUpdateModal.vue?vue&type=template&id=4b4693ba"
import script from "./InternalTuCreateUpdateModal.vue?vue&type=script&lang=js"
export * from "./InternalTuCreateUpdateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports